import { render, staticRenderFns } from "./ProjectDetailsWrapper.vue?vue&type=template&id=32e11010&"
import script from "./ProjectDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports